<template>
  <div>
    <PublicLayout>
      <header class="sub-header">
        <div class="container">
          <h1>專利權資訊</h1>
        </div>
      </header>
      <HeaderNav activeLink="patents" />
      <!-- main-section -->
      <section class="main-section">
        <section class="m-sec">
          <div class="container">
            <h2 class="section-title">
              【發明名稱】水溶性核蛋白保健飲料
              <br />
              <span class="patent-number">(專利第3899436號)</span>
            </h2>
            <p>
              本專利相當於組成物專利，是將成分配方專利化。所列數據乃基於生命科學研究所和FORDAYS公司共同的研究成果。其他公司不得銷售符合請求項目的產品。
            </p>
            <p>
              本專利是為了確保產品的獨創性，並避免類似品‧仿冒品的販售而獲得的專利，並不影射食品的有效性或功效。
            </p>
            <ul class="attention-list">
              <li>韓國‧中國也同樣取得相同內容的專利。</li>
              <li>現行的水溶性膠原核酸飲品，因維生素C增量，不適用於該專利。</li>
            </ul>
            <table class="light-table mt-4">
              <tr>
                <th width="22%">專利編號</th>
                <td class="font-weight-bold">專利第3899436號</td>
                <td width="20%" rowspan="6">
                  <VuePureLightbox
                    :thumbnail="
                      require('@/assets/public/images/patent/3899436.jpg')
                    "
                    :images="[
                      require('@/assets/public/images/patent/3899436.jpg'),
                    ]"
                  />
                </td>
              </tr>
              <tr>
                <th>發明名稱</th>
                <td>水溶性核蛋白保健飲料</td>
              </tr>
              <tr>
                <th>登錄日期</th>
                <td>2007年1月12日</td>
              </tr>
              <tr>
                <th>申請編號</th>
                <td>
                  發明專利申請編號 <br />
                  2002-135576
                </td>
              </tr>
              <tr>
                <th>申請日</th>
                <td>2002年5月10日</td>
              </tr>
              <tr>
                <th>專利權所有人</th>
                <td>
                  FORDAYS株式會社 <br />
                  LS株式會社
                </td>
              </tr>
            </table>

            <table class="light-table mt-4">
              <tr>
                <th width="22%">專利編號</th>
                <td class="font-weight-bold">ZL 2004 8 0000957.0</td>
                <td width="20%" rowspan="6">
                  <VuePureLightbox
                    :thumbnail="
                      require('@/assets/public/images/patent/cn_zl_2004.jpg')
                    "
                    :images="[
                      require('@/assets/public/images/patent/cn_zl_2004.jpg'),
                    ]"
                  />
                </td>
              </tr>
              <tr>
                <th>發明名稱</th>
                <td>保健飲料</td>
              </tr>
              <tr>
                <th>登錄日期</th>
                <td>2009年4月15日</td>
              </tr>
              <tr>
                <th>申請編號</th>
                <td>200480000957.0</td>
              </tr>
              <tr>
                <th>申請日</th>
                <td>2004年12月28日</td>
              </tr>
              <tr>
                <th>專利權所有人</th>
                <td>
                  FORDAYS株式會社 <br />
                  LS株式會社
                </td>
              </tr>
            </table>

            <table class="light-table mt-4 mb-4">
              <tr>
                <th width="22%">專利編號</th>
                <td class="font-weight-bold">10-0688867</td>
                <td width="20%" rowspan="6">
                  <VuePureLightbox
                    :thumbnail="
                      require('@/assets/public/images/patent/ko_10-0688867.jpg')
                    "
                    :images="[
                      require('@/assets/public/images/patent/ko_10-0688867.jpg'),
                    ]"
                  />
                </td>
              </tr>
              <tr>
                <th>發明名稱</th>
                <td>保健飲料</td>
              </tr>
              <tr>
                <th>登錄日期</th>
                <td>2007年2月22日</td>
              </tr>
              <tr>
                <th>申請編號</th>
                <td>KR20057005564</td>
              </tr>
              <tr>
                <th>申請日</th>
                <td>2005年3月30日</td>
              </tr>
              <tr>
                <th>專利權所有人</th>
                <td>
                  FORDAYS株式會社 <br />
                  LS株式會社
                </td>
              </tr>
            </table>

            <h2 class="section-title">
              【發明名稱】含有半胱胺酸肽的保健飲料
              <br />
              <span class="patent-number">(專利第6138048號)</span>
            </h2>
            <p>
              本專利是以特定的配合成分為基礎而製成的保健飲品之專利。適用於現行的水溶性膠原核酸飲品。
              <br />本專利乃基於生命科學研究所和FORDAYS公司共同的研究成果。其他公司不得銷售符合請求項目的產品。
              <br />
              本專利是為了確保產品的獨創性，並避免類似品‧仿冒品的販售而獲得的專利，並不影射食品的有效性或功效。
            </p>

            <table class="light-table mt-4 mb-4">
              <tr>
                <th width="22%">專利編號</th>
                <td class="font-weight-bold">專利第6138048號</td>
                <td width="20%" rowspan="6">
                  <VuePureLightbox
                    :thumbnail="
                      require('@/assets/public/images/patent/6138048.jpg')
                    "
                    :images="[
                      require('@/assets/public/images/patent/6138048.jpg'),
                    ]"
                  />
                </td>
              </tr>
              <tr>
                <th>發明名稱</th>
                <td>含有半胱胺酸肽的保健飲料</td>
              </tr>
              <tr>
                <th>登錄日期</th>
                <td>2017年5月12日</td>
              </tr>
              <tr>
                <th>申請編號</th>
                <td>
                  發明專利申請編號 <br />
                  2013-538440
                </td>
              </tr>
              <tr>
                <th>申請日</th>
                <td>2012年10月11日</td>
              </tr>
              <tr>
                <th>專利權所有人</th>
                <td>FORDAYS株式會社</td>
              </tr>
            </table>

            <h2 class="section-title">
              關於其他專利 <br />
              (專利第6153736號、專利第5820127號)
            </h2>
            <!-- <p>(專利編號第6153736號、專利編號第5820127號)</p> -->
            <p>
              本專利基於具有新穎且獨創性的機能性的發現，並根據FORDAYS和昭和大學的共同研究中所發現的證據而獲得專利。
              這些數據資料屬於FORDAYS公司。現行中的水溶性膠原核酸飲品適用於本專利中的每個請求項目。雖然這些專利是我們致力研究成果的一部分，但不影射食品的有效性或功效。
            </p>
            <p style="font-size: 14px">
              ※
              本產品不是藥物，不是用於疾病的治療，但對於日常保養有積極的意義。請遵守食品安全管理辦法，切勿誇大不實或宣稱療效，以免觸法！
            </p>
          </div>
        </section>
      </section>
      <!-- main-section -->
    </PublicLayout>
  </div>
</template>

<script>
import PublicLayout from "../../components/public/PublicLayout";
import HeaderNav from "../../components/public/headerNav/SafetyHeaderNav";
import VuePureLightbox from "vue-pure-lightbox";
export default {
  name: "PatentsScreen",
  components: {
    PublicLayout,
    HeaderNav,
    VuePureLightbox,
  },
};
</script>
<style lang="scss" scoped>
.patent-number {
  padding-left: 0.75rem;
}
</style>